import * as PropTypes from "prop-types";
import styled, { css } from "styled-components";
import { isIE } from "react-device-detect";
import RemoveRedEye from "../../images/ShowMoreIcon";
import Add from "../../images/PlusIcon";
import Edit from "../../images/EditIcon";
import { ICONS } from "./Icons";
import { iconWidth } from "./IconWidth";
import Delete from "../../images/DeleteIcon";

export default function BuildColumns(
  headers,
  icons,
  handleIconClicked,
  conditionalEditIcon,
  conditionalDeleteIcon,
  enableIcons,
) {
  const columns = headers.slice();
  if (enableIcons) {
    if (icons) {
      columns.push({
        Header: "",
        minWidth: iconWidth(icons, conditionalEditIcon),
        sortable: false,

        // eslint-disable-next-line react/prop-types
        Cell: ({ original }) => {
          const Icons = [];
          const showMoreIcon = icons.includes("show");
          const editIcon = icons.includes("edit");
          const add = icons.includes("add");
          const deleteIcon = icons.includes("delete");

          if (showMoreIcon) {
            Icons.push(
              <ShowMoreIcon
                id={`showMoreIcon${original.name || original.patientName}`}
                key="showMoreIcon"
                className="icon"
                showMoreIcon={showMoreIcon}
                onClick={handleIconClicked(ICONS.SHOW_MORE, original)}
              >
                <RemoveRedEye />
              </ShowMoreIcon>,
            );
          }

          if (!original.activeTreatmentPlanId && conditionalEditIcon) {
            Icons.push(
              <AddCircleIcon
                id={`addCircleIcon${original.name || original.patientName}`}
                key="addCircleIcon"
                className="icon"
                onClick={handleIconClicked(ICONS.ADD, original)}
                Add={add}
              >
                <Add enableSmallMarginTop />
              </AddCircleIcon>,
            );
          } else if (deleteIcon) {
            Icons.push(
              <DeleteIcon
                id={`deleteIcon${original.name}`}
                key="deleteIcon"
                className="icon"
                deleteIcon={deleteIcon}
                onClick={handleIconClicked(ICONS.DELETE, original)}
              >
                <Delete />
              </DeleteIcon>,
            );
          } else {
            Icons.push(
              <EditIcon
                id={`editIcon${original.name || original.patientName}`}
                className="icon"
                editIcon={editIcon}
                key="editIcon"
                onClick={handleIconClicked(ICONS.EDIT, original)}
              >
                <Edit />
              </EditIcon>,
            );
          }

          return <IconWrapper isIEBrowser={isIE}>{Icons}</IconWrapper>;
        },
      });
    }
  }

  return columns;
}

BuildColumns.propTypes = {
  original: PropTypes.object,
};

// TODO: check if works...
function ieMargin() {
  if (isIE) {
    return css`
      margin-left: 0;
      &:first-child div:nth-child(2) {
        margin-left: 10px;
      }

      svg {
        margin-left: 10px;
      }
    `;
  }
  return css`
    margin-left: 10px;
    svg {
      margin-left: 10px;
    }
  `;
}

const IconWrapper = styled.div`
  height: 100%;
  display: flex;
  justify-content: flex-end;
  ${ieMargin};
`;

const ShowMoreIcon = styled.div``;
const DeleteIcon = styled.div`
  ${!isIE && "margin-left: 14px;"};
`;

const EditIcon = styled.div`
  ${!isIE && "margin-left: 14px;"};
`;

const AddCircleIcon = styled.div`
  height: inherit;
  margin-left: 17px;
`;
